import AllWalletsPage from './AllWalletsPage';

export default AllWalletsPage;
